var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FavoritesCreateErr"},[(_vm.showCreateErrDialog)?_c('ReminderModal',{attrs:{"titleTxt":"温馨提示","content-txt":"免费用户，最多可新建1个收藏夹，已达上限","btnTxt":"点击升级会员"},on:{"close":_vm.close,"btnClick":_vm.btnClick}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }